import { MediaResolution } from '@setplex/tria-api'

export const RESOLUTION_TO_PIXELS: Record<MediaResolution, number> = {
  [MediaResolution.SD]: 480,
  [MediaResolution.HD]: 720,
  [MediaResolution.FHD]: 1080,
  [MediaResolution._2K]: 1440,
  [MediaResolution._4K]: 2160,
}

export const isQualityAllowedBySubscription = (
  requestedPixels: number,
  maxQuality?: MediaResolution
): boolean => {
  if (!maxQuality) return true

  const maxAllowedPixels = RESOLUTION_TO_PIXELS[maxQuality]
  return requestedPixels <= maxAllowedPixels
}

export const getMaxAllowedPixelsBySubscription = (
  maxQuality?: MediaResolution
): number => {
  if (!maxQuality) return Infinity
  return RESOLUTION_TO_PIXELS[maxQuality]
}
